/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import {
  FormGroup,
  TextArea,
  Button,
  DataTable,
  TableContainer,
  TableToolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableHeader,
  TableCell,
  TableToolbarContent,
  Tile,
  TimePicker,
  DatePicker,
  DatePickerInput,
} from 'carbon-components-react';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Close16 from '@carbon/icons-react/lib/close/16';
import Add16 from '@carbon/icons-react/lib/add/16';
import Save16 from '@carbon/icons-react/lib/save/16';
import Send16 from '@carbon/icons-react/lib/email/16';
import SimpleReactValidator from 'simple-react-validator';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import moment from 'moment';
import { showNotification } from '../../../../helpers/notification/BaseNotification';
import { entitiesLabels } from '../../../../helpers/Constants';
import { NoRecordsPlaceholder } from '../../../../helpers/jsonschemaform/DataTableExtention';
import EmailChips from '../../../../helpers/EmailChips';
import DateTimePicker from '../../../../helpers/DateTimePicker';

export default class DrillNotificationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationData: this.props.NotificationFormData || { activities: [] },
      modalActivityDeleteVisible: false,
      flagTime: false,
      selectedActivity: {
        id: null,
        activity: null,
        from: null,
        to: null,
        date: null,
      },
    };
    this.onDistributionListModify = this.onDistributionListModify.bind(this);
    this.handleActivityDetailVisibility = this.handleActivityDetailVisibility.bind(this);
    this.handleDeleteActivityModal = this.handleDeleteActivityModal.bind(this);
    this.onTimeToChanged = this.onTimeToChanged.bind(this);
    this.onTimeFromChanged = this.onTimeFromChanged.bind(this);
    this.onActivityChanged = this.onActivityChanged.bind(this);
    this.onSubmitActivity = this.onSubmitActivity.bind(this);
    this.onActivityDateChange = this.onActivityDateChange.bind(this);
    this.onActivityDelete = this.onActivityDelete.bind(this);
    this.saveNotificationForm = this.saveNotificationForm.bind(this);
    this.sendNotification = this.sendNotification.bind(this);

    this.validator = new SimpleReactValidator({
      validators: {
        emails: {
          // name the rule
          message: 'The :attribute must be a valid email address list semicolon separated',
          rule: (val, params, validator) =>
            validator.helpers.testRegex(
              val,
              // eslint-disable-next-line no-useless-escape
              /^(([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\s*;\s*|\s*$))+$/i
            ) && params.indexOf(val) === -1,
          required: true, // optional
        },
        time: {
          message: ':attribute must be a valid time',
          rule: (val, params, validator) =>
            validator.helpers.testRegex(val, /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]+$/) &&
            params.indexOf(val) === -1,
          required: true, // optional
        },
        datePicker: {
          message: 'The :attribute must be a valid date with mm/dd/yyyy format',
          rule: (val, params) => moment(val).isValid() && params.indexOf(val) === -1,
          required: true, // optional
        },
      },
    });
    this.validatorTime = new SimpleReactValidator({ locale: 'en' });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.NotificationFormData !== this.props.NotificationFormData) {
      this.setState({ notificationData: nextProps.NotificationFormData });
    }
  }

  onDistributionListModify(value) {
    // event.preventDefault();
    // const { value } = event.currentTarget;
    this.setState((prevState) => {
      const notificationData = { ...prevState.notificationData };
      notificationData.distributionList = value;
      return { notificationData };
    });
  }

  updateStatesTime = (inputName, inputValue, objName) => {
    if (inputValue == false) {
      this.setState({ flagTime: true });
      if (!this.validatorTime.allValid()) {
        this.validatorTime.showMessages();
      }
    } else {
      const statusCopy = { ...this.state };
      statusCopy[objName][inputName] = inputValue;
      statusCopy.flagTime = false;
      this.setState(statusCopy);
    }
  };

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;
    this.setState(statusCopy);
  };

  onTimeToChanged(event) {
    event.preventDefault();
    const { value } = event.currentTarget;
    this.setState((prevState) => {
      const selectedActivity = { ...prevState.selectedActivity };
      selectedActivity.to = value;
      selectedActivity.time = `${selectedActivity.from} - ${value}`;
      return { selectedActivity };
    });
  }

  onTimeFromChanged(event) {
    event.preventDefault();
    const { value } = event.currentTarget;
    this.setState((prevState) => {
      const selectedActivity = { ...prevState.selectedActivity };
      selectedActivity.from = value;
      selectedActivity.time = `${value} - ${selectedActivity.to}`;
      return { selectedActivity };
    });
  }

  onActivityChanged(event) {
    event.preventDefault();
    const { value } = event.currentTarget;
    this.setState((prevState) => {
      const selectedActivity = { ...prevState.selectedActivity };
      selectedActivity.activity = value;
      return { selectedActivity };
    });
  }

  onActivityDateChange(e) {
    this.setState((prevState) => {
      const selectedActivity = { ...prevState.selectedActivity };
      selectedActivity.date = moment(e[0]).format('YYYY-MM-DD');
      return { selectedActivity };
    });
  }

  onSubmitActivity(event) {
    event.preventDefault();
    if (
      this.validator.fieldValid('date') &&
      this.validator.fieldValid('from') &&
      this.validator.fieldValid('to') &&
      this.validator.fieldValid('activity') &&
      this.validator.fieldValid('diffTIme')
    ) {
      if (!this.validatorTime.allValid()) {
        this.setState((prevState) => {
          const notificationData = { ...prevState.notificationData };
          const selectedActivity = { ...prevState.selectedActivity };
          selectedActivity.time = `${selectedActivity.from} - ${selectedActivity.to}`;
          if (!selectedActivity.id) {
            selectedActivity.id = uuid();
            selectedActivity.idNotificationForm = prevState.notificationData.id;
            // notificationData.activities = prevState.notificationData.activities.concat(
            //   selectedActivity
            // );
            const notact = [selectedActivity];
            notificationData.activities = notact.concat(prevState.notificationData.activities);
            this.handleActivityDetailVisibility(null);
          } else {
            notificationData.activities = prevState.notificationData.activities
              .filter((item) => selectedActivity.id !== item.id)
              .concat(selectedActivity);
            this.handleActivityDetailVisibility(null);
          }
          return { notificationData };
        });
      } else {
        this.validator.showMessages();
        showNotification.warning(
          `${entitiesLabels.WARNING}`,
          `${entitiesLabels.EMERGENCYDRILL} Time is invalid `
        );
        this.forceUpdate();
      }
    } else {
      this.validator.showMessageFor('auditor');
      this.validator.showMessageFor('from');
      this.validator.showMessageFor('date');
      this.validator.showMessageFor('to');
      this.validator.showMessageFor('activity');
      this.validator.showMessageFor('diffTIme');
      this.forceUpdate();
    }
  }

  onActivityDelete() {
    this.setState((prevState) => {
      const notificationData = { ...prevState.notificationData };
      const selectedActivity = { ...prevState.selectedActivity };
      notificationData.activities = prevState.notificationData.activities.filter(
        (item) => selectedActivity.id !== item.id
      );
      return { notificationData };
    });
    this.handleDeleteActivityModal(null);
  }

  saveNotificationForm() {
    if (
      this.validator.fieldValid('distributionList') &&
      this.validator.fieldValid('activities')
    ) {
      this.props.onSave(this.state.notificationData);
    } else {
      this.validator.showMessageFor('distributionList');
      this.validator.showMessageFor('activities');

      this.forceUpdate();
    }
  }

  sendNotification() {
    if (
      this.validator.fieldValid('distributionList') &&
      // this.validator.fieldValid('responsible') &&
      this.validator.fieldValid('activities')
    ) {
      this.props.onSend(this.state.notificationData);
    } else {
      this.validator.showMessageFor('distributionList');
      // this.validator.showMessageFor('responsible');
      this.validator.showMessageFor('activities');

      this.forceUpdate();
    }
  }

  handleActivityDetailVisibility(id) {
    const activity = this.state.notificationData.activities.find((i) => i.id === id);
    this.setState((oldState) => ({
      modalActivityDetailVisible: !oldState.modalActivityDetailVisible,
      selectedActivity: activity || {},
    }));
  }

  handleDeleteActivityModal(id) {
    const activity = this.state.notificationData.activities.find((i) => i.id === id);
    this.setState((oldState) => ({
      modalActivityDeleteVisible: !oldState.modalActivityDeleteVisible,
      selectedActivity: activity || {},
    }));
  }

  renderDeleteActivitiesModal = () =>
    this.state.modalActivityDeleteVisible && (
      <div className="bx--modal bx--modal-tall is-visible">
        <div className="bx--modal-container">
          <div className="bx--modal-header">
            <h3 className="bx--modal-header__heading">Delete Team Activity</h3>
            <Button
              className="bx--modal-close"
              renderIcon={Close16}
              onClick={this.handleDeleteActivityModal}
              iconDescription=""
            />
          </div>

          <div className="bx--modal-content">
            <div className="bx--row bx--modal-content-detail">
              <div className="bx--col-lg-12 bx--col-md-12">
                <h5 className="align-center">Press confirm to remove selected activity</h5>
              </div>
            </div>
          </div>
          <div className="bx--modal-footer">
            <Button
              className="button--max-width"
              kind="secondary"
              onClick={this.handleDeleteActivityModal}
            >
              Cancel
            </Button>
            <Button className="button--max-width" kind="primary" onClick={this.onActivityDelete}>
              Confirm
            </Button>
          </div>
        </div>
      </div>
    );

  renderNewActivityModal = () => {
    const validationsTime = {
      validTime: this.validatorTime.message('validTime', this.state.flagTime, 'accepted'),
    };
    let diffFromTo = false;
    if (this.state.selectedActivity.to != null) {
      const timeEnd = moment(this.state.selectedActivity.to, 'hh:mm a');
      const timeStart = moment(this.state.selectedActivity.from, 'hh:mm a');
      const duration = moment.duration(timeEnd.diff(timeStart));
      const minutes = parseInt(duration.asMinutes()) % 60;
      const hours = parseInt(duration.asHours());
      if (minutes >= 0 && hours >= 0) diffFromTo = true;
    }
    const validationsModal = {
      date: this.validator.message('date', this.state.selectedActivity.date, 'required|datePicker'),
      from: this.validator.message('from', this.state.selectedActivity.from, 'required'),
      to: this.validator.message('to', this.state.selectedActivity.to, 'required'),
      activity: this.validator.message(
        'activity',
        this.state.selectedActivity.activity,
        'required'
      ),
      diffTIme: this.validator.message('diffTIme', diffFromTo, 'accepted'),
    };
    return (
      this.state.modalActivityDetailVisible && !this.state.drillReport?.drillPlan?.maskedValue && (
        <div className="bx--modal bx--modal-tall is-visible">
          <div className="bx--modal-container">
            <div className="bx--modal-header">
              <h3 className="bx--modal-header__heading">Add New Activity</h3>
              <Button
                className="bx--modal-close"
                renderIcon={Close16}
                onClick={this.handleActivityDetailVisibility}
                iconDescription=""
              />
            </div>

            <div className="bx--modal-content information">
              <div className="bx--row">
                <div className="bx--col-lg-6 bx--col-md-12 paddingTopRow">
                  <DatePicker
                    dateFormat="d/m/Y"
                    datePickerType="single"
                    id="date-picker"
                    light
                    locale="en"
                    short={false}
                    onChange={(e) => this.onActivityDateChange(e)}
                  >
                    <DatePickerInput
                      value={
                        this.state.selectedActivity.date
                          ? moment(this.state.selectedActivity.date).format('DD/MM/Y')
                          : ''
                      }
                      className="some-class"
                      disabled={this.props.editingDisabled}
                      iconDescription="Icon description"
                      id="date-picker-input-id"
                      invalid={validationsModal.date != null}
                      invalidText={validationsModal.date}
                      labelText="Activity Date*"
                      pattern="d{1,2}/d{4}"
                      placeholder="dd/mm/yyyy"
                      type="text"
                    />
                  </DatePicker>
                </div>
                <div className="bx--col-lg-6 bx--col-md-12">
                  <div className="bx--row">
                    <div className="bx--col-lg-6 bx--col-md-6 paddingTopRow">
                      <FormGroup key="occurrenceTime" legendText="Time From*">
                        <DateTimePicker
                          className="pickerActivity"
                          id="time-pickerFrom"
                          value={this.state.selectedActivity.from || ''}
                          type="time"
                          placeholder="hh:mm AM/PM"
                          name="from"
                          alt="selectedActivity"
                          invalid={validationsModal.from != null}
                          onChange={this.updateStatesTime}
                          disabled={false}
                        />
                      </FormGroup>
                    </div>
                    <div className="bx--col-lg-6 bx--col-md-6 paddingTopRow">
                      <FormGroup key="TimeTo" legendText="Time To*">
                        <DateTimePicker
                          className="pickerActivity"
                          value={this.state.selectedActivity.to || ''}
                          type="time"
                          placeholder="hh:mm AM/PM"
                          name="to"
                          id="time-pickerTo"
                          alt="selectedActivity"
                          invalid={validationsModal.to != null}
                          onChange={this.updateStatesTime}
                          disabled={false}
                        />
                      </FormGroup>
                    </div>
                    {validationsModal.diffTIme ||
                    validationsModal.to != null ||
                    validationsModal.to ? (
                      <div className="srv-validation-message "> Invalid time format </div>
                    ) : null}
                    {this.state.flagTime ? (
                      <div className="srv-validation-message "> Invalid time format </div>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12 paddingTopRow">
                  <FormGroup legendText="Activity*">
                    <TextArea
                      maxLength={5000}
                      labelText=""
                      id="inputActivity"
                      cols={250}
                      disabled={this.props.editingDisabled}
                      invalid={validationsModal.activity != null}
                      invalidText={validationsModal.activity}
                      light
                      placeholder="Input Activity"
                      rows={4}
                      value={this.state.selectedActivity.activity || ''}
                      onChange={this.onActivityChanged}
                    />
                  </FormGroup>
                </div>
              </div>
            </div>
            <div className="bx--modal-footer">
              <Button
                className="button--max-width"
                kind="secondary"
                onClick={this.handleActivityDetailVisibility}
              >
                Cancel
              </Button>
              <Button className="button--max-width" kind="primary" onClick={this.onSubmitActivity}>
                Confirm
              </Button>
            </div>
          </div>
        </div>
      )
    );
  };

  render() {
    const validations = {
      distributionList: this.validator.message(
        'distributionList',
        this.state.notificationData.distributionList,
        'required'
      ),
      activities: this.validator.message(
        'activities',
        this.state.notificationData.activities[0],
        'required'
      ),
    };

    const headers = [
      {
        key: 'activity',
        header: 'Activity',
      },
      {
        key: 'date',
        header: 'Date',
      },
      {
        key: 'time',
        header: 'Time From-TO',
      },
    ];
    return (
      <div>
        <Tile light>
          <DataTable
            useZebraStyles
            rows={
              this.state.notificationData.activities.sort((a, b) => {
                const dateA = new Date(a.date);
                const dateB = new Date(b.date);
                const hA = moment(a.from, 'HH:mm a');
                const hB = moment(b.from, 'HH:mm a');
                dateA.setHours(hA.hours(), hA.minutes());
                dateB.setHours(hB.hours(), hB.minutes());
                return dateA - dateB;
              }) || []
            }
            headers={headers}
            render={({ rows, getHeaderProps }) => (
              <TableContainer>
                <TableToolbar>
                  <TableToolbarContent className="table-toolbar-custom-content">
                    <div className="bx--col-lg-8 bx--col-md-10 table-toolbar-custon-content-info-start ">
                      <h6>List Of Drill Activities</h6>
                    </div>
                    {!this.props.editingDisabled && !this.props.drillReport.drillPlan?.maskedValue  ? (  //RITM0946012 - Anonimizzazione Modulo Emergency Drill
                    <div className="bx--col-lg-4 bx--col-md-2 table-toolbar-custon-content-info-end ">
                        <Button
                          onClick={this.handleActivityDetailVisibility}
                          kind="primary"
                          renderIcon={Add16}
                          disabled={this.props.editingDisabled}
                          iconDescription=""
                        >
                          Add New Activity
                        </Button>
                    </div>
                    )
                     : (
                      ''
                    )}
                    
                  </TableToolbarContent>
                </TableToolbar>
                {this.renderDeleteActivitiesModal()}
                {this.renderNewActivityModal()}
                <Table>
                  <TableHead>
                    <TableRow>
                      {headers.map((header) => (
                        <TableHeader {...getHeaderProps({ header })}>{header.header}</TableHeader>
                      ))}
                      <TableHeader className="align-center">Actions</TableHeader>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {!rows || rows.length < 1 ? (
                      <NoRecordsPlaceholder labelText="No Records" colSpan={headers.length + 1} />
                    ) : (
                      rows.map((row) => (
                        <TableRow key={`row_${row.id}`}>
                          {row.cells.map((cell) => (
                            <TableCell key={cell.id}>
                              {cell.info.header.includes('date')
                                ? moment(cell.value).format('DD/MM/YYYY')
                                : cell.info.header.includes('workSite')
                                ? cell.value?.name || 'N/A'
                                : cell.value}
                            </TableCell>
                          ))}
                          <TableCell key="action" className="tableActions align-center">
                            <div>
                            {!this.props.drillReport.drillPlan?.maskedValue && ( //RITM0946012 - Anonimizzazione Modulo Emergency Drill

                              <Button
                                onClick={() => this.handleActivityDetailVisibility(row.id)}
                                size="small"
                                renderIcon={Edit16}
                                iconDescription="Edit"
                                kind="ghost"
                                disabled={this.props.editingDisabled}
                              />
                            )}
                              {!this.props.drillReport.drillPlan?.maskedValue && ( //RITM0946012 - Anonimizzazione Modulo Emergency Drill
                              <Button
                                onClick={() => this.handleDeleteActivityModal(row.id)}
                                size="small"
                                renderIcon={Delete16}
                                iconDescription="Delete"
                                kind="ghost"
                                disabled={this.props.editingDisabled}
                              />
                              )}
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          />
          {validations.activities}
        </Tile>
        <Tile light>
          <div className="bx--col-lg-12 bx--col-md-12">
            <FormGroup legendText="Distribution List* (Personal Email Addresses are not allowed)">
              <EmailChips
                id="inputDistributionList"
                invalid={validations.distributionList != null}
                // invalidText={validations.distributionList}
                value={this.state.notificationData.distributionList || ''}
                disabled={this.props.editingDisabled}
                type="text"
                title="&#9888; Do Not use Personal Accounts"
                onChange={this.onDistributionListModify}
                masked={this.props.drillReport.drillPlan?.maskedValue} //RITM0946012 - Anonimizzazione Modulo Emergency Drill
              />
            </FormGroup>
          </div>
        </Tile>
        {!this.props.editingDisabled ? (
          <div className="bx--row table-toolbar-custon-content-info-end ">
            <Button
              size="default"
              renderIcon={Save16}
              kind="secondary"
              onClick={this.saveNotificationForm}
              disabled={this.props.editingDisabled}
              iconDescription=""
            >
              Save
            </Button>

            <Button
              size="default"
              renderIcon={Send16}
              disabled={this.props.editingDisabled}
              kind="primary"
              onClick={this.sendNotification}
              iconDescription=""
            >
              Send
            </Button>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

DrillNotificationForm.propTypes = {
  id: PropTypes.string.isRequired,
  NotificationFormData: PropTypes.object.isRequired,
  minDate: PropTypes.string.isRequired,
  maxDate: PropTypes.string.isRequired,
  workSites: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
};
DrillNotificationForm.defaultProps = {
  disabled: true,
};
